import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UsuarioModel } from '../../models/user-model';
import { meusPedidosModel } from '../../models/meus-pedidos-model';
import { EquipeModel } from '../../models/equipe-model';
import { AtletaModel } from '../../models/atleta-model';
import { AuthResponseModel } from '../../models/auth-response-model';
import { IDENTITY_AUTH_BASE_PATH, IDENTITY_USER_BASE_PATH } from './identity-routes';

@Injectable({
  providedIn: 'root'
})
export class IdentityApiService {
  private readonly apiUrl = `${environment.url_api}`;
  private readonly authBasePath = IDENTITY_AUTH_BASE_PATH;
  private readonly userBasePath = IDENTITY_USER_BASE_PATH;

  constructor(private http: HttpClient) { }

  login(usuario: string, senha: string): Observable<AuthResponseModel> {
    return this.http.post<AuthResponseModel>(`${this.apiUrl}${this.authBasePath}/login`, { usuario, senha });
  }

  cadastrar(user: UsuarioModel): Observable<AuthResponseModel> {
    return this.http.post<AuthResponseModel>(`${this.apiUrl}${this.authBasePath}/cadastro`, user);
  }

  redefinirSenha(emailOrCpf: String): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}${this.authBasePath}/redefinirSenha`, [emailOrCpf]);
  }

  gerarNovaSenha(code: string, senha: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}${this.authBasePath}/gerarNovaSenha`, { code, senha });
  }

  getDadosUsuario(): Observable<UsuarioModel> {
    return this.http.get<UsuarioModel>(`${this.apiUrl}${this.userBasePath}/dados-usuario`);
  }

  atualizarDadosUsuario(dados: UsuarioModel): Observable<UsuarioModel> {
    return this.http.put<UsuarioModel>(`${this.apiUrl}${this.userBasePath}/atualizar-dados-usuario`, dados);
  }

  getPedidosUsuario(): Observable<meusPedidosModel[]> {
    return this.http.get<meusPedidosModel[]>(`${this.apiUrl}${this.userBasePath}/lista-pedidos`);
  }

  cadastrarEquipe(dados: EquipeModel): Observable<EquipeModel> {
    return this.http.post<EquipeModel>(`${this.apiUrl}${this.userBasePath}/cadastrar-equipe`, dados);
  }

  buscarEquipes(nome: string): Observable<EquipeModel[]> {
    return this.http.get<EquipeModel[]>(`${this.apiUrl}${this.userBasePath}/busca-equipes?nome=${nome}`);
  }

  getLinkIntegracaoStrava(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}${this.userBasePath}/link-integracao-strava`);
  }

  getDadosAtletaStrava(): Observable<AtletaModel> {
    return this.http.get<AtletaModel>(`${this.apiUrl}${this.userBasePath}/dados-atleta-strava`);
  }
}
